'use client';

import { useCookieBanner, ConsentCategory } from 'cookiebanner-finally';
import { CookieSettings } from './CookieSettings';
import { Button } from '@/shadcn/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/shadcn/ui/dialog';
import { motion } from 'framer-motion';

export function CookieBanner() {
  const { isVisible, acceptAll, denyAll } = useCookieBanner();

  if (!isVisible) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: '2rem' }}
      animate={{
        opacity: 1,
        y: 0,
      }}
      transition={{ duration: 0.3, delay: 0.6 }}
      className="fixed bottom-0 lg:bottom-8 w-[95%] lg:w-full z-50 left-[2.5%] right-[2.5%] lg:left-0 lg:right-0"
    >
      <div className="flex flex-col left-[50%] -translate-x-1/2 relative gap-[3rem] lg:gap-[4.5rem] max-w-[90rem] bg-black/80 backdrop-blur-[1rem] border border-white/[15%] p-[3.5rem] pb-[4.5rem] lg:p-[4rem] shadow-2xl rounded-[1rem]">
        <div className="flex flex-col gap-[2rem]">
          <h2 className="font-nunito uppercase text-white text-[2.5rem] lg:text-[3.5rem]">
            This website uses cookies
          </h2>
          <p className="text-offwhite font-nunito leading-relaxed">
            We use cookies to improve the user-friendliness of our website. By continuing to use our website, you agree to the use of cookies in accordance with our cookie policy.
          </p>
        </div>
        <div className="flex lg:flex-row flex-col items-center lg:justify-between gap-[2rem] lg:gap-[4rem]">
          <Button
            onClick={acceptAll}
            className="flex-1 px-0 py-4 text-offwhite bg-white/5 max-w-[98%] lg:max-w-[25rem] hover:bg-white/[15%] transition-all duration-300"
            variant="blur-outline"
          >
            Accept all
          </Button>

          <Button
            onClick={denyAll}
            className="flex-1 py-0 text-offwhite/40 max-w-[98%] lg:max-w-none hover:opacity-75 transition-all duration-300"
          >
            Reject all
          </Button>

          <Dialog>
            <DialogTrigger asChild>
              <Button
                className="flex-1 gap-[1rem] text-offwhite/40 lg:max-w-[23rem] hover:opacity-75 transition-all duration-300"
              >
                <span>View details</span>
                <svg
                  className="w-[2rem] aspect-square -translate-y-[.2rem]"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M19.137 13.436c.036-.3.06-.612.06-.936q0-.486-.072-.936l2.028-1.584a.496.496 0 0 0 .12-.612l-1.92-3.324c-.12-.216-.372-.288-.588-.216l-2.388.96a7 7 0 0 0-1.62-.936l-.36-2.544a.48.48 0 0 0-.48-.408h-3.84a.467.467 0 0 0-.468.408l-.36 2.544a7.2 7.2 0 0 0-1.62.936l-2.388-.96a.475.475 0 0 0-.588.216l-1.92 3.324a.465.465 0 0 0 .12.612l2.028 1.584c-.048.3-.084.624-.084.936s.024.636.072.936L2.841 15.02a.496.496 0 0 0-.12.612l1.92 3.324c.12.216.372.288.588.216l2.388-.96a7 7 0 0 0 1.62.936l.36 2.544c.048.24.24.408.48.408h3.84c.24 0 .444-.168.468-.408l.36-2.544a7.2 7.2 0 0 0 1.62-.936l2.388.96c.216.084.468 0 .588-.216l1.92-3.324a.465.465 0 0 0-.12-.612zm-7.14 2.664a3.61 3.61 0 0 1-3.6-3.6c0-1.98 1.62-3.6 3.6-3.6s3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6"
                  />
                </svg>
              </Button>
            </DialogTrigger>
            <DialogContent className="bg-black/50 backdrop-blur-[1rem] border border-white/[15%] shadow-2xl !rounded-[1rem] !w-full max-w-[90vw] lg:max-w-4xl !p-0">
              <DialogHeader>
                <DialogTitle></DialogTitle>
                <CookieSettings />
                <DialogDescription></DialogDescription>
              </DialogHeader>
            </DialogContent>
          </Dialog>
        </div>
      </div>
    </motion.div>
  );
}
